import type { IconNode } from '../types';

/**
 * @name grid-lines-offset
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAzdjE4IiAvPgogIDxwYXRoIGQ9Ik0xMyAzdjE4IiAvPgogIDxwYXRoIGQ9Ik0zIDExaDE4IiAvPgogIDxwYXRoIGQ9Ik0zIDE3aDE4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/grid-lines-offset
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const gridLinesOffset: IconNode = [
  ['path', { d: 'M7 3v18', key: 'bbkbws' }],
  ['path', { d: 'M13 3v18', key: 'k5a9nd' }],
  ['path', { d: 'M3 11h18', key: '11qctw' }],
  ['path', { d: 'M3 17h18', key: '3xqu03' }],
];

export default gridLinesOffset;
